import { arrayContains } from 'utils';
import { UPDATE_USER_PAYMENT_INFOS_REQUEST } from 'redux/actions/payment';

export const isUpdateUserPaymentLoading = (state) => arrayContains(state.payment.openRequests, [UPDATE_USER_PAYMENT_INFOS_REQUEST]);
